export const GET_PACKAGES_LIST = null;
export const SELECTED_PACKAGE_ID = null;
export const GET_PACKAGE_BY_ID = null;
export const SELECTED_PACKAGE_SPONSORSHIP_DETAILS = null;